import { Button, Grid, List } from '@material-ui/core';
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CardMessage from '../../../../../components/CardMessage/CardMessage';
import { TodayOccurrencesEnum } from '../../../../../models/enum/TodayOccurrencesEnum';
import { AppState } from '../../../../../store';
import { getTodayOccurrencesStatus } from '../../../../../store/actions/punchCardActions';
import { CondominiumReducerData } from '../../../../../store/reducers/condominiumReducer';
import { PunchCardReducerData } from '../../../../../store/reducers/punchCardReducer';
import OccurrencesListItem from './OccurrencesListItem';
import OccurrencesTodayDetailedStatusDialog from './OccurrencesTodayDetailedStatusDialog';

const OccurrencesTodayStatusList: React.FC = () => {
  const dispatch = useDispatch();
  const [
    openReferencePunchCardDialog,
    setOpenReferencePunchCardDialog,
  ] = useState(false);
  const [occurrencesTypeSelected, setOccurrencesTypeSelected] = useState<
    string
  >('');
  const [dialogTitle, setDialogTitle] = useState<string>('');

  const { condominiumSelected }: CondominiumReducerData = useSelector(
    (state: AppState) => state.condominiumReducer,
  );

  const {
    loadingOccurrencesTodayStatus,
    todayOccurrencesStatus,
  }: PunchCardReducerData = useSelector(
    (state: AppState) => state.punchCardReducer,
  );

  const handleReferencePunchCardDialogOpen = (
    occurrenceType: string,
    title = '',
  ) => {
    setOccurrencesTypeSelected(occurrenceType);
    setDialogTitle(title);
    setOpenReferencePunchCardDialog(true);
  };

  const findTodayOccurrencesStatus = async (reference: number) => {
    dispatch(getTodayOccurrencesStatus(reference));
  };

  return (
    <>
      <OccurrencesTodayDetailedStatusDialog
        open={openReferencePunchCardDialog}
        title={dialogTitle}
        occurrencesTypeSelected={occurrencesTypeSelected}
        handleClose={() => setOpenReferencePunchCardDialog(false)}
      />

      {condominiumSelected && (
        <Grid container alignItems="center" justify="flex-end">
          <Grid item>
            <Button
              style={{ marginTop: 8, marginRight: 8 }}
              onClick={() =>
                findTodayOccurrencesStatus(condominiumSelected.referencia)
              }
              disabled={loadingOccurrencesTodayStatus}
              variant="text"
              color="primary"
            >
              Recarregar
            </Button>
          </Grid>
        </Grid>
      )}

      <List
        style={{
          height: `calc(100% - '122px)`,
          overflowY: 'auto',
        }}
      >
        {!todayOccurrencesStatus && !loadingOccurrencesTodayStatus ? (
          <CardMessage
            icon={
              <SentimentDissatisfiedIcon
                style={{ fontSize: 100, opacity: 0.4 }}
              />
            }
            message="Nenhum resultado"
          />
        ) : (
          <>
            <OccurrencesListItem
              title="Trabalhando"
              mainText={todayOccurrencesStatus?.quantidadePresentes}
              descriptionText={`De ${todayOccurrencesStatus?.quantidadeTotal} funcionários`}
              loading={loadingOccurrencesTodayStatus}
              onClick={() =>
                todayOccurrencesStatus?.quantidadePresentes !== 0 &&
                handleReferencePunchCardDialogOpen(
                  TodayOccurrencesEnum.PRESENTE,
                  'Colaboradores Trabalhando',
                )
              }
            />
            <OccurrencesListItem
              title="Folgas"
              mainText={todayOccurrencesStatus?.quantidadeFolgas}
              descriptionText={`De ${todayOccurrencesStatus?.quantidadeTotal} funcionários`}
              loading={loadingOccurrencesTodayStatus}
              onClick={() =>
                todayOccurrencesStatus?.quantidadeFolgas !== 0 &&
                handleReferencePunchCardDialogOpen(
                  TodayOccurrencesEnum.FOLGA,
                  'Colaboradores de Folga',
                )
              }
            />
            <OccurrencesListItem
              title="Férias"
              mainText={todayOccurrencesStatus?.quantidadeFerias}
              descriptionText={`De ${todayOccurrencesStatus?.quantidadeTotal} funcionários`}
              loading={loadingOccurrencesTodayStatus}
              onClick={() =>
                todayOccurrencesStatus?.quantidadeFerias !== 0 &&
                handleReferencePunchCardDialogOpen(
                  TodayOccurrencesEnum.HORASFERIAS,
                  'Colaboradores em Férias',
                )
              }
            />
            <OccurrencesListItem
              title="Atestados"
              mainText={todayOccurrencesStatus?.quantidadeAtestado}
              descriptionText={`De ${todayOccurrencesStatus?.quantidadeTotal} funcionários`}
              loading={loadingOccurrencesTodayStatus}
              onClick={() =>
                todayOccurrencesStatus?.quantidadeAtestado !== 0 &&
                handleReferencePunchCardDialogOpen(
                  TodayOccurrencesEnum.HORASATESTADO,
                  'Colaboradores com Atestados',
                )
              }
            />
            <OccurrencesListItem
              title="Afastamentos"
              mainText={todayOccurrencesStatus?.quantidadeAfastamento}
              descriptionText={`De ${todayOccurrencesStatus?.quantidadeTotal} funcionários`}
              loading={loadingOccurrencesTodayStatus}
              onClick={() =>
                todayOccurrencesStatus?.quantidadeAfastamento !== 0 &&
                handleReferencePunchCardDialogOpen(
                  TodayOccurrencesEnum.HORASAFASTAMENTO,
                  'Colaboradores Afastados',
                )
              }
            />
            <OccurrencesListItem
              title="Sem Marcação"
              tooltipText="Funcionários que já iniciaram seu expediente de trabalho e ainda não marcaram seu ponto"
              mainText={todayOccurrencesStatus?.quantidadeSemMarcacao}
              descriptionText={`De ${todayOccurrencesStatus?.quantidadeTotal} funcionários`}
              loading={loadingOccurrencesTodayStatus}
              onClick={() =>
                todayOccurrencesStatus?.quantidadeSemMarcacao !== 0 &&
                handleReferencePunchCardDialogOpen(
                  TodayOccurrencesEnum.SEMMARCACAORECEBIDA,
                  'Colaboradores Sem Marcação',
                )
              }
            />
            <OccurrencesListItem
              title="Turno Não Iniciado"
              tooltipText="Funcionários que ainda não iniciaram seu expediente de trabalho"
              mainText={todayOccurrencesStatus?.quantidadeTurnoNaoIniciado}
              descriptionText={`De ${todayOccurrencesStatus?.quantidadeTotal} funcionários`}
              loading={loadingOccurrencesTodayStatus}
              onClick={() =>
                todayOccurrencesStatus?.quantidadeTurnoNaoIniciado !== 0 &&
                handleReferencePunchCardDialogOpen(
                  TodayOccurrencesEnum.TURNONAOINICIADO,
                  'Colaboradores Com Turno Não Iniciado',
                )
              }
            />
          </>
        )}
      </List>
    </>
  );
};

export default OccurrencesTodayStatusList;
